import { useState, useEffect } from 'react';
import { Building } from '../../../types';
import { listBuildings } from '../../../services/api/endpoints/buildings';
import { useAuth } from '../../../contexts/AuthContext';

export const useBuildings = () => {
  const { user } = useAuth();
  const [buildings, setBuildings] = useState<Building[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBuildings = async () => {
    if (!user?.token) {
      setIsLoading(false);
      return;
    }
    
    setIsLoading(true);
    setError(null);
    
    try {
      const data = await listBuildings(user.token);
      setBuildings(data);
    } catch (err: any) {
      console.error('Error fetching buildings:', err);
      setError(err.message || 'Failed to fetch buildings');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBuildings();
  }, [user?.token]);

  return { buildings, isLoading, error, refresh: fetchBuildings };
};
